export default __webpack_public_path__ + "static/media/main-logo.4c578d2d.jpeg";